import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_VALIDATION_LANG: {
  VALIDATION_IN_PROGRESS_MESSAGE: MvnCodeFE;
  VALIDATION_ISSUE_REPORT: MvnCodeFE;
  VALIDATION_ISSUE_CHECK: MvnCodeFE;
  VALIDATION_ISSUE_REPORT_EXPORT_SUCCEED: MvnCodeFE;
  VALIDATION_ISSUE_REPORT_EXPORT_FAILED: MvnCodeFE;
  VALIDATION_ISSUE_CHECK_SUCCEED: MvnCodeFE;
  VALIDATION_ISSUE_CHECK_FAILED: MvnCodeFE;
  VALIDATION_MESSAGE_DIALOG_TITLE: MvnCodeFE;
  VALIDATION_MESSAGE_REQUIRED: MvnCodeFE;
  VALIDATION_MESSAGE_INVALID: MvnCodeFE;
  VALIDATION_EXCLUDED_DATASET_TOOLTIP: MvnCodeFE;

  SELECTION_BAR_SELECTED_COUNT: MvnCodeFE;
  SELECTION_BAR_SELECT_ALL_BUTTON: MvnCodeFE;
  SELECTION_BAR_UNCHECK_BUTTON: MvnCodeFE;

  VALIDATION_PROGRESS_DIALOG_TITLE: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_STARTING: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_DOWNLOADING_ASSETS: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_FETCHING_DATASETS: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_LOADING_FILES: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_LOADING_RULES: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_LOADING_CT: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_LOADING_METADATA: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_VALIDATING: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_PACKAGING: MvnCodeFE;
  VALIDATION_PROGRESS_PHASE_DONE: MvnCodeFE;
  VALIDATION_PROGRESS_DETAIL_COUNT: MvnCodeFE;
  VALIDATION_PROGRESS_ERROR_TITLE: MvnCodeFE;
  VALIDATION_PROGRESS_CANCEL: MvnCodeFE;
  VALIDATION_PROGRESS_CONFIRM: MvnCodeFE;

  VALIDATION_EXPORT_DIALOG_TITLE: MvnCodeFE;
  VALIDATION_EXPORT_TOTAL_PACKAGE: MvnCodeFE;
  VALIDATION_EXPORT_VALIDATION_REPORT_GROUP: MvnCodeFE;
  VALIDATION_EXPORT_DEFINE_XML_GROUP: MvnCodeFE;
  VALIDATION_EXPORT_DOCUMENTS_GROUP: MvnCodeFE;
  VALIDATION_EXPORT_DATASETS_GROUP: MvnCodeFE;
  VALIDATION_EXPORT_DATASETS_SUMMARY: MvnCodeFE;
  VALIDATION_EXPORT_NO_DEFINE_XML: MvnCodeFE;
  VALIDATION_EXPORT_NO_DOCUMENTS: MvnCodeFE;
  VALIDATION_EXPORT_NO_DATASETS: MvnCodeFE;
  VALIDATION_EXPORT_BUTTON: MvnCodeFE;
  VALIDATION_EXPORT_CANCEL: MvnCodeFE;
  VALIDATION_EXPORT_SUCCESS: MvnCodeFE;
  VALIDATION_EXPORT_FAILURE: MvnCodeFE;
} = {
  VALIDATION_IN_PROGRESS_MESSAGE: {
    ko: "검증 진행 중입니다.\n종료될 때까지 기다려 주세요.",
    en: "Validation is in progress.\nPlease wait until it is complete.",
  },

  VALIDATION_ISSUE_REPORT: {
    ko: "이슈 보고서",
    en: "Issue Report",
  },

  VALIDATION_ISSUE_CHECK: {
    ko: "유효성 검사",
    en: "Validation",
  },

  VALIDATION_ISSUE_REPORT_EXPORT_SUCCEED: {
    ko: "결과 패키지 압축 파일 다운로드를 완료했습니다.",
    en: "The result package zip file has been successfully downloaded.",
  },

  VALIDATION_ISSUE_REPORT_EXPORT_FAILED: {
    ko: "결과 패키지 압축 파일 다운로드에 실패했습니다.",
    en: "Failed to download the result package zip file.",
  },

  VALIDATION_ISSUE_CHECK_SUCCEED: {
    ko: "유효성 검사를 완료했습니다.",
    en: "Validation has been completed.",
  },

  VALIDATION_ISSUE_CHECK_FAILED: {
    ko: "유효성 검사에 실패했습니다.",
    en: "Failed to validation.",
  },

  VALIDATION_MESSAGE_DIALOG_TITLE: {
    ko: "다음 오류를 확인하십시오.",
    en: "Please check the following error.",
  },

  VALIDATION_MESSAGE_REQUIRED: {
    ko: "{category} Tab {property} 값을 확인해주세요.",
    en: "{category} Tab {property} is required.",
  },

  VALIDATION_MESSAGE_INVALID: {
    ko: "{category} Tab {recognizableVariable} 의 {property} 값이 유효하지 않습니다.",
    en: "{category} Tab {property} of {recognizableVariable} is invalid.",
  },
  VALIDATION_EXCLUDED_DATASET_TOOLTIP: {
    ko: "데이터 동기화(재흐름 또는 재저장)가 필요하여 Validation 대상에서 제외됩니다.",
    en: "Excluded from validation targets as data synchronization (re-flow or re-save) is required.",
  },

  SELECTION_BAR_SELECTED_COUNT: {
    ko: "{value}개 선택됨",
    en: "{value} selected",
  },
  SELECTION_BAR_SELECT_ALL_BUTTON: {
    ko: "전체 선택",
    en: "Select All",
  },
  SELECTION_BAR_UNCHECK_BUTTON: {
    ko: "선택 항목 해제",
    en: "Uncheck",
  },

  VALIDATION_PROGRESS_DIALOG_TITLE: {
    ko: "유효성 검사 진행",
    en: "Validating Data",
  },
  VALIDATION_PROGRESS_PHASE_STARTING: {
    ko: "검사를 시작하는 중...",
    en: "Starting validation...",
  },
  VALIDATION_PROGRESS_PHASE_DOWNLOADING_ASSETS: {
    ko: "검증 자산을 다운로드하는 중...",
    en: "Downloading validation assets...",
  },
  VALIDATION_PROGRESS_PHASE_FETCHING_DATASETS: {
    ko: "데이터셋을 가져오는 중...",
    en: "Fetching datasets...",
  },
  VALIDATION_PROGRESS_PHASE_LOADING_FILES: {
    ko: "데이터셋 파일을 로드하는 중...",
    en: "Loading dataset files...",
  },
  VALIDATION_PROGRESS_PHASE_LOADING_RULES: {
    ko: "규칙을 로드하는 중...",
    en: "Loading rules...",
  },
  VALIDATION_PROGRESS_PHASE_LOADING_CT: {
    ko: "Controlled Terminology를 로드하는 중...",
    en: "Loading Controlled Terminology...",
  },
  VALIDATION_PROGRESS_PHASE_LOADING_METADATA: {
    ko: "메타데이터를 로드하는 중...",
    en: "Loading metadata...",
  },
  VALIDATION_PROGRESS_PHASE_VALIDATING: {
    ko: "파일을 검사하는 중...",
    en: "Validating files...",
  },
  VALIDATION_PROGRESS_PHASE_PACKAGING: {
    ko: "결과 패키지를 생성하는 중...",
    en: "Packaging results...",
  },
  VALIDATION_PROGRESS_PHASE_DONE: {
    ko: "유효성 검사가 완료되었습니다.",
    en: "Validation has been completed.",
  },
  VALIDATION_PROGRESS_DETAIL_COUNT: {
    ko: "{total}개 중 {completed}개 처리",
    en: "Processing {completed} of {total}",
  },
  VALIDATION_PROGRESS_ERROR_TITLE: {
    ko: "유효성 검사에 실패했습니다.",
    en: "Validation failed.",
  },
  VALIDATION_PROGRESS_CANCEL: {
    ko: "취소",
    en: "Cancel",
  },
  VALIDATION_PROGRESS_CONFIRM: {
    ko: "확인",
    en: "Confirm",
  },

  VALIDATION_EXPORT_DIALOG_TITLE: {
    ko: "내보내기",
    en: "Export",
  },
  VALIDATION_EXPORT_TOTAL_PACKAGE: {
    ko: "Total Package",
    en: "Total Package",
  },
  VALIDATION_EXPORT_VALIDATION_REPORT_GROUP: {
    ko: "Validation Report",
    en: "Validation Report",
  },
  VALIDATION_EXPORT_DEFINE_XML_GROUP: {
    ko: "Define-XML",
    en: "Define-XML",
  },
  VALIDATION_EXPORT_DOCUMENTS_GROUP: {
    ko: "Documents",
    en: "Documents",
  },
  VALIDATION_EXPORT_DATASETS_GROUP: {
    ko: "Datasets",
    en: "Datasets",
  },
  VALIDATION_EXPORT_DATASETS_SUMMARY: {
    ko: "{first} 외 {rest}개",
    en: "{first} and {rest} more",
  },
  VALIDATION_EXPORT_NO_DEFINE_XML: {
    ko: "Define-XML이 선택되지 않았습니다.",
    en: "Define-XML was not selected.",
  },
  VALIDATION_EXPORT_NO_DOCUMENTS: {
    ko: "등록된 문서 파일이 없습니다.",
    en: "No documents are attached.",
  },
  VALIDATION_EXPORT_NO_DATASETS: {
    ko: "Validation 대상 데이터셋이 없습니다.",
    en: "No datasets are available.",
  },
  VALIDATION_EXPORT_BUTTON: {
    ko: "내보내기",
    en: "Export",
  },
  VALIDATION_EXPORT_CANCEL: {
    ko: "취소",
    en: "Cancel",
  },
  VALIDATION_EXPORT_SUCCESS: {
    ko: "파일 내보내기가 완료되었습니다.",
    en: "Export package has been downloaded.",
  },
  VALIDATION_EXPORT_FAILURE: {
    ko: "파일 내보내기에 실패했습니다.",
    en: "Failed to export the package.",
  },
};

MvnCodeInitiate(CONVERTER_VALIDATION_LANG);
